// data
// import { highlightedData } from "../../../lib/highlightedData";

// style
import "./style.scss";

const HomeHighlighted = () => {
	return (
		<section className="highlighted">
			<div className="highlighted__container">
				<div className="highlighted__container-header"></div>
				{/* <div className="highlighted__container-item">
					{highlightedData.map((item) => (
						<a href={item.link} key={item.id} target="_blank" rel="noreferrer">
							<img src={item.img} alt="#" />
						</a>
					))}
				</div> */}
				<script src="https://apps.elfsight.com/p/platform.js" defer></script>
				<div className="elfsight-app-d3b7111e-b024-4e70-a2fa-19f5bb3c159c"></div>
				{/* <div className="elfsight-app-f955c37e-5d10-45e3-9f79-46e0e6738088"></div> */}
			</div>
		</section>
	);
};

export default HomeHighlighted;
